import { addLabelArray } from "helpers/addLabelArray";
import { convertToObjById } from "helpers/convertToObject";
import { adminUnitsTypes } from "../adminUnits/types";

export const LOAD_UNITS_V2 = "LOAD_UNITS_V2"
export const SET_UNITS_V2 = "SET_UNITS_V2"
export const SET_UNITS_INPUTS = "SET_UNITS_INPUTS"
export const SET_UNITS_CONFIG_V2 = "SET_UNITS_CONFIG_V2"
export const UPDATE_UNIT_PIPE_CONDITIONS = "UPDATE_UNIT_PIPE_CONDITIONS"
export const UPDATE_UNIT_PLATFORM_CONDITIONS = "UPDATE_UNIT_PLATFORM_CONDITIONS"
export const UNITS_ERROR_V2 = "UNITS_ERROR_V2"
export const RESET_UNITS_ERROR_V2 = "RESET_UNITS_ERROR_V2"
export const UPDATE_UNIT_IMEI = "UPDATE_UNIT_IMEI"
export const UPDATE_DISPENSER_IMEI = "UPDATE_DISPENSER_IMEI"
export const UPDATE_UNIT_TANKS = "UPDATE_UNIT_TANKS"
export const SELECT_STATION = "SELECT_STATION"
export const SELECT_COMPANY = "SELECT_COMPANY"
export const CLEAN_STATION = "CLEAN_STATION"
export const CLEAN_COMPANY = "CLEAN_COMPANY"
export const CLEAN_UNITS_CONFIG = "CLEAN_UNITS_CONFIG"
export const SET_UNIT_TAGS_STATION = "SET_UNIT_TAGS_STATION"
export const SET_UNITS_VERSIONS = "SET_UNITS_VERSIONS"
export const MARK_UNIT_TAGS_STATION = "MARK_UNIT_TAGS_STATION"
export const RESET_UNIT_TAGS_STATION = "RESET_UNIT_TAGS_STATION"
export const CHECK_UNIT_TAG_DISPENSER = "CHECK_UNIT_TAG_DISPENSER"
export const RESET_UNIT_TAG_DISPENSER = "RESET_UNIT_TAG_DISPENSER"
export const SET_UNIT_VIEW = "SET_UNIT_VIEW"
export const SET_SUGGESTED_UNITS = "SET_SUGGESTED_UNITS"
export const SET_UNITS_NFC = "SET_UNITS_NFC"
export const UPDATE_UNIT_MAINTENANCE = "UPDATE_UNIT_MAINTENANCE"
export const UPDATE_UNIT_NFC = "UPDATE_UNIT_NFC"
export const DELETE_UNIT_NFC = "DELETE_UNIT_NFC"

//test
export const UPDATE_UNIT_CONFIG = "UPDATE_UNIT_CONFIG";
export const SET_UNITS_SNAKBAR = "SET_UNITS_SNAKBAR";
export const RESET_UNITS_SNAKBAR = "RESET_UNITS_SNAKBAR";

export const TO_SAVE_UNIT_DATA = "TO_SAVE_UNIT_DATA";
export const RESET_UNIT_DATA = "RESET_UNIT_DATA";
export const UNIT_STATION_TRANSFER = "UNIT_STATION_TRANSFER";
export const GET_UNITS_STATIONS_PARENT = "GET_UNITS_STATIONS_PARENT";
export const SET_SUGGESTED_FAILED = "SET_SUGGESTED_FAILED";

const {
  ADD_ADMIN_UNITS,
  EDIT_ADMIN_UNIT,
  REMOVE_UNIT,
  SET_TRANSFER_BILL,
  RESTORE_INITIAL_STATE,
  UPDATE_UNIT_INVENTORY,
  GET_UNIT_CUSTOMERS,
  GET_CREDIT_LIMIT,
  GET_WHOLESALER_CREDIT_CONDITIONS,
  UPDATE_WHOLESALER_CREDIT_CONDITIONS,
} = adminUnitsTypes;

const TIMEOUT_MESSAGE = "TIMEOUT";

const updateUnitConf = (configObj, unitId, hasInventory) => {
  if (!configObj?.[unitId]) return configObj;
  return {
    ...configObj,
    [unitId]: {
      ...configObj[unitId],
      conf: { ...configObj[unitId].conf, hasInventory },
    },
  };
};

const updateUnit = (configObj, unitId, unitPatch) => {
  if (!configObj?.[unitId]) return configObj;
  return {
    ...configObj,
    [unitId]: { ...configObj[unitId], ...unitPatch },
  };
};

const initialState = {
  loading: false,
  units: {},
  unitsMap: [],
  unitsConfig: {},
  unitsConfigArr: [],
  nfcList: [],
  storeUnitsConfig: null,
  tagsStation: [],
  selectedTags: [],
  unitsToSave: null,
  stepDown: null,
  isError: {
    error: false,
    errorMsj: "",
  },
  stationSelect: "",
  companySelected: "",
  company: null,
  stationsOpt: [],
  station: null,
  configTypes: [],
  loadInfo: true,
  unitTypes: [],
  unitTypesObj: {},
  versions: [],
  stationsParent: [],
  snackbar: {
    isActive: false,
    message: "",
    color: "",
  },
  isTagsView: false,
  suggestedUnits: { units: null, responseTime: null },
  suggestionFailed: false,
};

export const unitsReducerV2 = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_UNITS_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case SET_UNIT_VIEW:
      return {
        ...state,
        isTagsView: !state.isTagsView,
      };
    case LOAD_UNITS_V2:
      return {
        ...state,
        loading: true,
      };

    case SET_UNITS_V2:
      const nPayload = payload.map((unit) => {
        return {
          ...unit,
          value: unit.id,
          label: `${unit.number} - ${unit.type}`,
        };
      });
      const addingLabel = convertToObjById(nPayload);
      const uTypes = [...new Set(payload.map(({ type }) => type))].map(
        (type) => {
          return {
            value: type,
            label: type,
          };
        },
      );

      const unitTypesObj = uTypes.reduce((acc, type) => {
        return {
          ...acc,
          [type.value]: type.label,
        };
      }, {});
      return {
        ...state,
        loading: false,
        units: addingLabel,
        unitsMap: nPayload,
        loadInfo: false,
        unitTypes: uTypes,
        unitTypesObj: unitTypesObj,
      };
    case SET_UNITS_NFC: {
      return {
        ...state,
        loading: false,
        nfcList: payload
      }
    }

    case UPDATE_UNIT_NFC: {
      const { idUnit: idU, idNfcTag, uuidTag } = payload;
      return {
        ...state,
        unitsConfig: {
          ...state.unitsConfig,
          [idU]: {
            ...state.unitsConfig[idU],
            nfcTag: { id: idNfcTag, uuidTag: uuidTag }
          }
        },
        loading: false
      };
    }

    case DELETE_UNIT_NFC: {
      return {
        ...state,
        unitsConfig: {
          ...state.unitsConfig,
          [payload]: {
            ...state.unitsConfig[payload],
            nfcTag: null
          }
        },
      }
    }

    case UPDATE_UNIT_MAINTENANCE: {
      const { id, form } = payload;

      return {
        ...state,
        unitsConfig: {
          ...state.unitsConfig,
          [id]: {
            ...state.unitsConfig[id],
            isMaintenance: form.isMaintenance
          }
        },
        units: {
          ...state.units,
          [id]: {
            ...state.units[id],
            isMaintenance: form.isMaintenance
          }
        },
        loading: false
      };
    }

    case UPDATE_UNIT_PIPE_CONDITIONS: {
      const { idUnit } = payload;

      return {
        ...state,
        unitsConfig: {
          ...state.unitsConfig,
          [idUnit]: {
            ...state.unitsConfig[idUnit],
            pipeConditions: [{ ...payload }],
          },
        },
        loading: false,
      };
    }

    case UPDATE_UNIT_PLATFORM_CONDITIONS: {
      const { idUnit } = payload;

      return {
        ...state,
        unitsConfig: {
          ...state.unitsConfig,
          [idUnit]: {
            ...state.unitsConfig[idUnit],
            platformConditions: [{ ...payload }],
          },
        },
        loading: false,
      };
    }

    case SET_UNITS_CONFIG_V2:
      const { units, types } = payload;
      const addingLabelTanks = units.reduce((acc, unit) => {
        return {
          ...acc,
          [unit.id]: {
            ...unit,
            value: unit.id,
            label: unit.number,
            saveActive: false,
          },
        };
      }, {});
      const addingLabelTanksArr = units.map((unit) => {
        const dispensers =
          unit.dispensers !== null
            ? unit.dispensers.map((dispenser) => {
              return {
                ...dispenser,
                value: dispenser.id,
                label: dispenser.name,
                saveActive: false,
              };
            })
            : null;

        return {
          ...unit,
          dispensers: dispensers,
          value: unit.id,
          label: `${unit.number} - ${unit.unit_type}`,
          saveActive: false,
          // Mapeo cruzado de type y unit_type en backend (UNIT_CONF_BASE):
          // 'type', u.price_type
          // 'unit_type', u.type
          // Este cambio alinea la semántica de priceType y type
          type: unit.unit_type,
          priceType: unit.type,
        };
      });

      return {
        ...state,
        loading: false,
        unitsConfig: addingLabelTanks,
        unitsConfigArr: addingLabelTanksArr,
        storeUnitsConfig: addingLabelTanks,
        configTypes: types.map((type, idx) => {
          return {
            ...type,
            id: `${idx}-${new Date().getMilliseconds()}`,
          };
        }),
      };

    case UPDATE_UNIT_CONFIG: {
      const { id, unitId } = payload;
      if (unitId && unitId.length > 0) {
        let newDispenser = state.unitsConfig[unitId];
        newDispenser.dispensers = newDispenser.dispensers.map((disp) => {
          if (disp.id === payload.resp.id) {
            return { ...disp, imei: payload.resp.imei };
          } else {
            return disp;
          }
        });
        return {
          ...state,
          unitsConfig: { ...state.unitsConfig, [unitId]: newDispenser },
          loading: false,
        };
      }

      const updatedUnitsConfigArr = state.unitsConfigArr.map((unit) =>
        unit.id === id ? { ...unit, ...payload } : unit
      );

      return {
        ...state,
        unitsConfig: {
          ...state.unitsConfig,
          [id]: {
            ...state.unitsConfig[id],
            ...payload,
          },
        },
        unitsConfigArr: updatedUnitsConfigArr,
        loading: false,
      };
    }

    case UPDATE_DISPENSER_IMEI:
      // toStringPayload = JSON.stringify(state)
      // newState = JSON.parse(toStringPayload)
      // const newDispensers = newState.unitsConfig[payload.idUnit].dispensers.map( dispenser => {
      //   return dispenser.id === payload.id
      //     ? { ...dispenser, imei: payload.imei }
      //     : dispenser
      // })
      // newState.unitsConfig[payload.idUnit].dispensers = newDispensers
      let newState;
      return { ...newState, loading: false };

    case UPDATE_UNIT_TANKS:
      // toStringPayload = JSON.stringify(state)
      // newState = JSON.parse(toStringPayload)
      // newState.unitsConfig[payload.id] = payload
      return { ...newState, loading: false };

    case SELECT_COMPANY:
      return {
        ...state,
        companySelected: payload,
      };
    case SELECT_STATION:
      return {
        ...state,
        stationSelect: payload,
      };
    case SET_UNIT_TAGS_STATION:
      return {
        ...state,
        tagsStation: payload,
      };
    case SET_UNITS_VERSIONS:
      return {
        ...state,
        versions: payload,
        loading: false,
      };

    case MARK_UNIT_TAGS_STATION:
      //15832 mark dispensers tags
      const activeTag = state.tagsStation.map((tg) => {
        return tg.id === payload ? { ...tg, select: !tg.select } : tg;
      });
      return {
        ...state,
        tagsStation: activeTag,
      };
    case RESET_UNIT_TAGS_STATION:
      return {
        ...state,
        tagsStation: [],
        selectedTags: [],
      };
    case CHECK_UNIT_TAG_DISPENSER:
      return {
        ...state,
      };
    case CLEAN_STATION:
      return {
        ...state,
        stationSelect: "",
      };
    case CLEAN_COMPANY:
      return {
        ...state,
        companySelected: "",
      };
    case CLEAN_UNITS_CONFIG:
      return {
        ...state,
        unitsConfig: {},
      };
    case UNITS_ERROR_V2:
      return {
        ...state,
        loading: false,
        isError: {
          error: true,
          errorMsj: payload,
        },
      };

    case RESET_UNITS_ERROR_V2:
      return {
        ...state,
        loading: false,
        isError: {
          error: false,
          errorMsj: "",
        },
      };
    case SET_UNITS_SNAKBAR:
      return {
        ...state,
        loading: false,
        snackbar: {
          isActive: true,
          message: payload.message,
          color: payload.color,
        },
      };
    case RESET_UNITS_SNAKBAR:
      return {
        ...state,
        snackbar: {
          isActive: false,
          message: "",
          color: "",
        },
      };
    case TO_SAVE_UNIT_DATA:
      const { id, ...restData } = payload;
      const existingUnitData = state?.unitsToSave?.[id];

      const keepStepDown = {
        ...state.stepDown,
        [id]: state.storeUnitsConfig[id],
      };

      const unitsConfigUpdate = {
        ...state.unitsConfig,
        [id]: {
          ...state.unitsConfig[id],
          ...restData,
          saveActive: true,
        },
      };

      const unitsToSaveUpdate = {
        ...state.unitsToSave,
        [id]: {
          ...(existingUnitData || {}),
          ...payload,
        },
      };
      return {
        ...state,
        unitsConfig: unitsConfigUpdate,
        unitsToSave: unitsToSaveUpdate,
        stepDown: keepStepDown,
      };

    case RESET_UNIT_DATA:
      return {
        ...state,
        unitsToSave: null,
        unitsConfig: state.storeUnitsConfig,
        stepDown: null,
      };

    case GET_UNITS_STATIONS_PARENT:
      const parentsLabel = addLabelArray(payload, "name");
      return {
        ...state,
        stationsParent: parentsLabel,
      };
    case UNIT_STATION_TRANSFER:
      let unitsT = { ...state.unitsConfig };
      let unitsTArr = [...state.unitsConfigArr];

      let filterUnits = [];
      if (payload.idStation) {
        filterUnits = unitsTArr.filter((unit) => unit.id !== payload.idUnit);
        delete unitsT[payload];
      } else {
        unitsT[payload.idUnit].idOperating = payload.idOperating;
        let idx = unitsTArr.findIndex((unit) => unit.id === payload.idUnit);
        unitsTArr[idx].idOperating = payload.idOperating;
      }

      return {
        ...state,
        unitsConfig: unitsT,
        unitsConfigArr: filterUnits,
      };
    case SET_SUGGESTED_FAILED:
      return {
        ...state,
        suggestionFailed: payload,
      };
    case SET_SUGGESTED_UNITS:
      return {
        ...state,
        suggestedUnits: payload,
        suggestionFailed: payload.responseTime == TIMEOUT_MESSAGE,
      };
    case ADD_ADMIN_UNITS:
      return { ...state, unitsConfigArr: [...state.unitsConfigArr, payload] };

    case EDIT_ADMIN_UNIT:
      let unistEdited = [...state.unitsConfigArr];
      const idx = unistEdited.findIndex((unit) => unit.id === payload.id);
      if (idx !== -1) {
        let unit = unistEdited[idx];
        unit = {
          ...unit,
          ...payload,
          driverName: payload?.driver ? payload.driver : unit.driverName,
          helperName: payload?.helper ? payload.helper : unit.helperName,
        };
        unistEdited[idx] = unit;
      }
      return {
        ...state,
        unitsConfigArr: unistEdited,
      };

    case REMOVE_UNIT:
      return {
        ...state,
        unitsConfigArr: state.unitsConfigArr.filter(
          (unit) => unit.id !== payload,
        ),
      };
    
    case UPDATE_UNIT_INVENTORY: {
      const { unitId, hasInventory } = payload;

      return {
        ...state,
        unitsConfig: updateUnitConf(state.unitsConfig, unitId, hasInventory),
        storeUnitsConfig: updateUnitConf(state.storeUnitsConfig, unitId, hasInventory),
        unitsConfigArr: state.unitsConfigArr.map((unit) =>
          unit.id === unitId
            ? { ...unit, conf: { ...unit?.conf, hasInventory } }
            : unit
        ),
      };
    }
    
    case SET_TRANSFER_BILL: {
      const { idUnit: unitId, unitPlates, creLicense, ...bill } = payload;
      const updatedUnitsArr = state.unitsConfigArr.map((unit) => {
        return unit.id === unitId
          ? { ...unit, unitPlates, creLicense, unitBilling: { ...unit.unitBilling, ...bill } }
          : unit;
      });
      return {
        ...state,
        unitsConfigArr: updatedUnitsArr,
        unitsConfig: {
          ...state.unitsConfig,
          [unitId]: {
            ...state.unitsConfig[unitId],
            unitPlates,
            creLicense,
            unitBilling: { ...state.unitsConfig[unitId]?.unitBilling, ...bill },
          }
        },
        storeUnitsConfig: {
          ...state.storeUnitsConfig,
          [unitId]: {
            ...state.storeUnitsConfig?.[unitId],
            unitPlates,
            creLicense,
            unitBilling: { ...state.storeUnitsConfig?.[unitId]?.unitBilling, ...bill },
          }
        },
      };
    }

    case GET_UNIT_CUSTOMERS: {
      const { unitId, customer = null } = payload;

      return {
        ...state,
        unitsConfig: updateUnit(state.unitsConfig, unitId, { customer }),
        storeUnitsConfig: updateUnit(state.storeUnitsConfig, unitId, { customer }),
        unitsConfigArr: state.unitsConfigArr.map((unit) =>
          unit.id === unitId
            ? { ...unit, customer }
            : unit
        ),
      };
    }

    case GET_CREDIT_LIMIT: {
      const { unitId, creditLimit = null } = payload;

      return {
        ...state,
        unitsConfig: updateUnit(state.unitsConfig, unitId, {
          customer: { ...state.unitsConfig[unitId]?.customer, creditLimit },
        }),
        storeUnitsConfig: updateUnit(state.storeUnitsConfig, unitId, {
          customer: { ...state.storeUnitsConfig[unitId]?.customer, creditLimit },
        }),
        unitsConfigArr: state.unitsConfigArr.map((unit) =>
          unit.id === unitId
            ? { ...unit, customer: { ...unit.customer, creditLimit } }
            : unit
        ),
      };
    }
    
    case GET_WHOLESALER_CREDIT_CONDITIONS: {
      const { unitId, creditConditions } = payload;
      // Marca la unidad como ya consultada para no re-fetchear, exista o no registro.
      const patch = creditConditions
        ? { creditConditions, conditionsFetched: true }
        : { conditionsFetched: true };

      return {
        ...state,
        unitsConfig: updateUnit(state.unitsConfig, unitId, patch),
        storeUnitsConfig: updateUnit(state.storeUnitsConfig, unitId, patch),
        unitsConfigArr: state.unitsConfigArr.map((unit) =>
          unit.id === unitId
            ? { ...unit, ...patch }
            : unit
        ),
      };
    }

    case UPDATE_WHOLESALER_CREDIT_CONDITIONS: {
      const { idUnit: unitId, ...conditionsRest } = payload;

      return {
        ...state,
        unitsConfig: updateUnit(state.unitsConfig, unitId, {
          creditConditions: { ...state.unitsConfig[unitId]?.creditConditions, ...conditionsRest },
        }),
        storeUnitsConfig: updateUnit(state.storeUnitsConfig, unitId, {
          creditConditions: { ...state.storeUnitsConfig[unitId]?.creditConditions, ...conditionsRest },
        }),
        unitsConfigArr: state.unitsConfigArr.map((unit) =>
          unit.id === unitId
            ? { ...unit, creditConditions: { ...unit.creditConditions, ...conditionsRest } }
            : unit
        ),
      };
    }

    case RESTORE_INITIAL_STATE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
